import React, { useState, useMemo } from "react";
import "./SalaryApproval.css";
import SalaryApprovalDetail from "./SalaryApprovalDetail";

// Моковые данные
const mockDepartments = [
  {
    id: 1,
    name: "Конструкторский отдел",
    initiator: "Аскарова Ж.",
    date: new Date(2025, 7, 1), // Август 2025
    approvers: [
      {
        role: "Директор",
        name: "Бекбауов С.",
        status: "На рассмотрении",
      },
      {
        role: "Финансовый руководитель",
        name: "Тлебаева Б.",
        status: "На рассмотрении",
      },
      {
        role: "Руководитель отдела",
        name: "Казиев Б.",
        status: "На рассмотрении",
      },
    ],
    submissionDate: new Date(2025, 7, 30), // 30.08.2025
  },
  {
    id: 2,
    name: "Отдел управления проектами ОЗ",
    initiator: "Аскарова Ж.",
    date: new Date(2025, 7, 1), // Август 2025
    approvers: [
      {
        role: "Директор",
        name: "Бекбауов С.",
        status: "На рассмотрении",
      },
      {
        role: "Финансовый руководитель",
        name: "Тлебаева Б.",
        status: "Согласован",
      },
      {
        role: "Руководитель отдела",
        name: "Казиев Б.",
        status: "На рассмотрении",
      },
    ],
    submissionDate: new Date(2025, 7, 30), // 30.08.2025
  },
  {
    id: 3,
    name: "Архитектурный отдел МЖК",
    initiator: "Аскарова Ж.",
    date: new Date(2025, 7, 1), // Август 2025
    approvers: [
      {
        role: "Директор",
        name: "Бекбауов С.",
        status: "На рассмотрении",
      },
      {
        role: "Финансовый руководитель",
        name: "Тлебаева Б.",
        status: "Согласован",
      },
      {
        role: "Руководитель отдела",
        name: "Казиев Б.",
        status: "На рассмотрении",
      },
    ],
    submissionDate: new Date(2025, 7, 30), // 30.08.2025
  },
  {
    id: 4,
    name: "Архитектурный отдел МЖК",
    initiator: "Аскарова Ж.",
    date: new Date(2025, 7, 1), // Август 2025
    approvers: [
      {
        role: "Директор",
        name: "Бекбауов С.",
        status: "Согласован",
      },
      {
        role: "Финансовый руководитель",
        name: "Тлебаева Б.",
        status: "Согласован",
      },
      {
        role: "Руководитель отдела",
        name: "Казиев Б.",
        status: "Согласован",
      },
    ],
    submissionDate: new Date(2025, 7, 30), // 30.08.2025
  },
  {
    id: 5,
    name: "Архитектурный отдел МЖК",
    initiator: "Аскарова Ж.",
    date: new Date(2025, 7, 1), // Август 2025
    approvers: [
      {
        role: "Директор",
        name: "Бекбауов С.",
        status: "Согласован",
      },
      {
        role: "Финансовый руководитель",
        name: "Тлебаева Б.",
        status: "Отклонено",
      },
      {
        role: "Руководитель отдела",
        name: "Казиев Б.",
        status: "Согласован",
      },
    ],
    submissionDate: new Date(2025, 7, 30), // 30.08.2025
  },
  {
    id: 6,
    name: "Проектный отдел",
    initiator: "Иванов И.И.",
    date: new Date(2025, 6, 1), // Июль 2025
    approvers: [
      {
        role: "Директор",
        name: "Бекбауов С.",
        status: "Согласован",
      },
      {
        role: "Финансовый руководитель",
        name: "Тлебаева Б.",
        status: "Согласован",
      },
      {
        role: "Руководитель отдела",
        name: "Петров П.П.",
        status: "Согласован",
      },
    ],
    submissionDate: new Date(2025, 6, 25), // 25.07.2025
  },
];

function SalaryApproval() {
  const formatMonthYear = (date) => {
    const months = [
      "Январь",
      "Февраль",
      "Март",
      "Апрель",
      "Май",
      "Июнь",
      "Июль",
      "Август",
      "Сентябрь",
      "Октябрь",
      "Ноябрь",
      "Декабрь",
    ];
    return `${months[date.getMonth()]} ${date.getFullYear()}`;
  };

  const formatDate = (date) => {
    if (!date) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);
    return `${day}.${month}.${year}`;
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "На рассмотрении":
        return "⏳";
      case "Согласован":
        return "✓";
      case "Отклонено":
        return "✗";
      default:
        return "";
    }
  };

  const getStatusClassName = (status) => {
    switch (status) {
      case "На рассмотрении":
        return "status-pending";
      case "Согласован":
        return "status-approved";
      case "Отклонено":
        return "status-rejected";
      default:
        return "";
    }
  };

  const getRowClassName = (department) => {
    if (!department.approvers || department.approvers.length === 0) {
      return "";
    }

    const statuses = department.approvers.map((a) => a.status);
    const hasRejected = statuses.some((s) => s === "Отклонено");
    const hasPending = statuses.some((s) => s === "На рассмотрении");
    const allApproved = statuses.every((s) => s === "Согласован");

    if (hasRejected) {
      return "salary-table__row--rejected";
    }
    if (allApproved) {
      return "salary-table__row--approved";
    }
    if (hasPending) {
      return "salary-table__row--pending";
    }
    return "";
  };

  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);

  // Фильтрация по дате
  const filteredDepartments = useMemo(() => {
    if (!selectedDate) {
      return mockDepartments;
    }

    return mockDepartments.filter((dept) => {
      const deptMonth = dept.date.getMonth();
      const deptYear = dept.date.getFullYear();
      const selectedMonth = selectedDate.getMonth();
      const selectedYear = selectedDate.getFullYear();

      return deptMonth === selectedMonth && deptYear === selectedYear;
    });
  }, [selectedDate]);

  // Получаем уникальные даты для фильтра
  const uniqueDates = useMemo(() => {
    const dates = new Set();
    mockDepartments.forEach((dept) => {
      const key = `${dept.date.getFullYear()}-${dept.date.getMonth()}`;
      dates.add(key);
    });
    return Array.from(dates)
      .map((key) => {
        const [year, month] = key.split("-").map(Number);
        return new Date(year, month, 1);
      })
      .sort((a, b) => b - a); // Сортировка от новых к старым
  }, []);

  // Если выбран отдел, показываем детальный вид
  if (selectedDepartment) {
    return (
      <SalaryApprovalDetail
        department={selectedDepartment}
        onBack={() => setSelectedDepartment(null)}
      />
    );
  }

  return (
    <div className="salary-approval">
      <h2 className="salary-approval__title">Согласование зарплаты</h2>

      {/* Фильтр по дате */}
      <div className="salary-approval__filter">
        <label htmlFor="date-filter" className="salary-approval__filter-label">
          Фильтр по дате:
        </label>
        <select
          id="date-filter"
          className="salary-approval__filter-select"
          value={
            selectedDate
              ? `${selectedDate.getFullYear()}-${selectedDate.getMonth()}`
              : ""
          }
          onChange={(e) => {
            if (e.target.value) {
              const [year, month] = e.target.value.split("-").map(Number);
              setSelectedDate(new Date(year, month, 1));
            } else {
              setSelectedDate(null);
            }
          }}
        >
          <option value="">Все периоды</option>
          {uniqueDates.map((date, index) => (
            <option
              key={index}
              value={`${date.getFullYear()}-${date.getMonth()}`}
            >
              {formatMonthYear(date)}
            </option>
          ))}
        </select>
      </div>

      {/* Таблица */}
      {filteredDepartments.length === 0 ? (
        <div className="salary-table__empty">
          <p>Нет данных для отображения</p>
        </div>
      ) : (
        <div className="salary-table__container">
          <table className="salary-table">
            <thead>
              <tr>
                <th>Отдел</th>
                <th>Инициатор</th>
                <th>Дата</th>
                <th>Статус</th>
                <th>Дата отправки на согласование</th>
              </tr>
            </thead>
            <tbody>
              {filteredDepartments.map((department) => (
                <tr
                  key={department.id}
                  className={`salary-table__row ${getRowClassName(department)}`}
                  onClick={() => setSelectedDepartment(department)}
                  style={{ cursor: "pointer" }}
                >
                  <td className="salary-table__department">
                    {department.name}
                  </td>
                  <td className="salary-table__initiator">
                    {department.initiator || "-"}
                  </td>
                  <td className="salary-table__date">
                    <span className="salary-table__date-icon">📅</span>
                    {formatMonthYear(department.date)}
                  </td>
                  <td className="salary-table__status">
                    {department.approvers && department.approvers.length > 0 ? (
                      <div className="salary-table__status-list">
                        {department.approvers.map((approver, index) => (
                          <div
                            key={index}
                            className={`salary-table__approver ${getStatusClassName(
                              approver.status,
                            )}`}
                          >
                            <span className="salary-table__approver-role">
                              {approver.role} ({approver.name}):
                            </span>
                            <span
                              className={`salary-table__approver-status ${getStatusClassName(
                                approver.status,
                              )}`}
                            >
                              <span className="salary-table__status-icon">
                                {getStatusIcon(approver.status)}
                              </span>
                              {approver.status}
                            </span>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <span className="salary-table__no-status">-</span>
                    )}
                  </td>
                  <td className="salary-table__submission-date">
                    {department.submissionDate ? (
                      <>
                        <span className="salary-table__date-icon">📅</span>
                        {formatDate(department.submissionDate)}
                      </>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default SalaryApproval;
